import styled from '@emotion/styled';

const Wrapper = styled.div<Partial<Props>>`
    display: flex;
    align-items: center;
    gap: ${(props) => (props.wide ? '8px' : '4px')};
    padding: ${(props) => (props.wide ? '12px 20px' : null)};
    border-radius: 4px;
    background-color: ${(props) => (props.wide ? 'var(--main-color-blue)' : null)};
`;

const Message = styled.span<Partial<Props>>`
    color: var(--warn);
    font-size: ${(props) => (props.wide ? 'var(--font-large)' : 'var(--font-medium)')};
    font-weight: var(--font-bold);
`;

interface Props {
    message?: string;
    wide?: boolean;
    style?: React.CSSProperties;
}

/**
 * 入力エラーメッセージ
 */
export const FormError: React.FC<Props> = ({ message, wide, style }) => {
    if (!message) {
        return null;
    }
    return (
        <Wrapper wide={wide} style={style}>
            <Message wide={wide}>{message}</Message>
        </Wrapper>
    );
};
